import Token from '@/utils/Token';

export default {
    /**
     * Conteúdo do release + flag `exibir` (false quando este usuário já leu).
     */
    release() {
        return axios.get('/api/novidade', Token.getHeader());
    },

    /**
     * Confirma a leitura — o dialog não volta a aparecer até o próximo release.
     */
    ler() {
        return axios.post('/api/novidade/ler', {}, Token.getHeader());
    },
};
